// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"30742379","192":"a4b19615","456":"c0a3f8cb","841":"d1176e35","994":"d7a6160b"}[chunkId] + ".chunk.js";
};